<template>
  <FormulateForm ref="form-ref" v-model="formValues" class="form-section" :errors="errors">
    <FormulateInput
      class="form-section__input w-50"
      type="text"
      name="name"
      :label="$t('customField.field.fieldName')"
      :placeholder="$t('customField.placeholder.fieldName')"
      validation="bail|required:trim|max:40,length"
      validation-behavior="live"
      :help="true"
      :disabled="isLoading"
    />

    <div class="form-section__type">
      <p class="form-section__text">
        {{ $t('customField.text.fieldType') }}
      </p>
      <p class="form-section__bold-text">
        {{ $t(typeSelected.title) }}
      </p>
    </div>

    <div class="form-section__toggle">
      <p class="form-section__text"> 
        {{ `${$t('customField.text.fieldStatus')}: ${formValues.is_active ? $t('customField.type.active') : $t('customField.type.inactive')}` }}
      </p>
      <McToggle
        v-model="formValues.is_active"
        :disabled="isLoading"
      />
    </div>
  </FormulateForm>
</template>

<script>
import McToggle from '@/components/McToggle'
import { isEqual } from 'lodash'

import apiErrorV2Mappings from '../../lib/constants/api-error-v2-mappings.js'

export default {
  components: {
    McToggle,
  },
  inject: {
    selectedItem: {
      default: () => ({})
    }
  },
  props: {
    typeSelected: {
      type: Object,
      default: () => {
        return {
          key: 'TEXT',
          title: 'Teks',
        }
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    formType: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      errors: {},
      invalidFormValues: {},

      formValues: {
        name: '',
        type: this.typeSelected.key,
        is_active: true,
      },
      initialFormValues: {},
    }
  },
  computed: {
    hasChanged() {
      return !isEqual(this.formValues, this.initialFormValues)
    },
    invalidFieldKeys() {
      return Object.keys(this.invalidFormValues)
    },
  },
  watch: {
    formValues(newValue) {
      if (this.invalidFieldKeys.length === 0) return

      this.invalidFieldKeys.forEach(key => {
        if (this.invalidFormValues[key] != newValue[key]) {
          // delete the field from the state to show errors
          this.$delete(this.errors, key)
          this.$delete(this.invalidFormValues, key)
        }
      })

      // empty the errorResponse if all error key is deleted
      if (this.invalidFieldKeys.length === 0) {
        this.invalidFormValues = {}
      }
    }
  },
  mounted() {
    if (this.formType != 'update') return

    Object.keys(this.formValues).forEach((key) => {
      this.$set(this.formValues, key, this.selectedItem[key])
    })

    this.initialFormValues = { ...this.formValues }
  },
  methods: {
    SetErrorsV2(errorsv2) {
      if (errorsv2.issues && errorsv2.issues.length > 0) {
        errorsv2.issues.forEach((issue) => {
          let key = issue.path.join('.')

           // Set invalid values to state
          this.$set(this.invalidFormValues, key, this.formValues[key])

          let errorMsg = apiErrorV2Mappings[key][issue.code]

          if (typeof errorMsg === 'function') {
            errorMsg = errorMsg()
          } 

          this.$set(
            this.errors,
            key,
            errorMsg || this.$t('global.somethingWentWrong'),
          )
        })
      }
    },
    GetFormValues() {
      if (this.$refs['form-ref'].hasErrors) {
        this.$mcToast.error(this.$t('global.somethingWentWrong'))
        return false
      }

      let newValues = {}

      if (this.formType == 'create') {
        newValues = { ...this.formValues }
      } else {
        Object.keys(this.formValues).forEach((key) => {
          if (this.formValues[key] == this.initialFormValues[key]) return
  
          newValues[key] = this.formValues[key]
        })
      }

      return newValues
    },
  },
}
</script>

<style lang="scss" scoped>
.form-section {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__input {
    :deep(.formulate-input) {
      padding: 0;
    }
  }

  &__checkbox {
    display: flex;
  }

  &__text {
    color: $mep-color-text-300;
  }

  &__bold-text {
    color: $mep-color-text-400;
    font-weight: 600;
  }

  p {
    margin: 0;
  }

  &__checkbox {
    display: flex;
    gap: 8px;
  }

  &__status-limit {
    display: flex;
    gap: 12px;
  }
}
</style>
